import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Badge, Box, BrandMark, Button, Card, CheckIcon, List, ListItem, ListItemButton, ListItemText, Page, PageHeader, SIZE, Typography, useToast, } from '@platform/design-system';
import { useSession } from "../auth/session.js";
import { describeError } from "../http/errors.js";
export const TIER_LABEL = { pool: 'Pool tier', silo: 'Dedicated cell' };
export const ROLE_LABEL = {
    PlatformAdmin: 'Platform admin',
    TenantAdmin: 'Admin',
    Manager: 'Manager',
    Agent: 'Agent',
};
/** The frame for signed-in pages that sit outside the app shell (the workspace picker). */
export function StandaloneFrame({ children }) {
    return (_jsx(Box, { component: "main", sx: {
            minHeight: '100vh',
            bgcolor: 'background.canvas',
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 3, md: 6 },
        }, children: _jsx(Box, { sx: {
                width: '100%',
                maxWidth: SIZE.contentMaxWidth,
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0,
            }, children: children }) }));
}
/** `/switch-tenant` — one identity, several workspaces (SaaS Lens memberships). */
export function SwitchTenantScreen({ onSwitched, onSignedOut, }) {
    const { principal, switchTenant, signOut } = useSession();
    const toast = useToast();
    const [busyId, setBusyId] = useState(null);
    if (!principal)
        return null;
    const count = principal.workspaces.length;
    const choose = (w) => {
        setBusyId(w.tenantId);
        void switchTenant(w.tenantId)
            .then(() => {
            toast.success(`Switched to ${w.tenantName}`);
            onSwitched(w);
        })
            .catch((e) => {
            setBusyId(null);
            toast.error(describeError(e, `Could not open ${w.tenantName}`));
        });
    };
    return (_jsx(StandaloneFrame, { children: _jsxs(Page, { width: "narrow", children: [_jsx(PageHeader, { title: "Choose a workspace", meta: `Signed in as ${principal.name} · ${count} ${count === 1 ? 'workspace' : 'workspaces'}`, actions: _jsx(Button, { onClick: () => void signOut().then(onSignedOut), children: "Sign out" }) }), _jsx(Card, { flush: true, children: _jsx(List, { disablePadding: true, "aria-label": "Workspaces", children: principal.workspaces.map((w, i) => {
                            const current = w.tenantId === principal.tenantId;
                            return (_jsx(ListItem, { disablePadding: true, divider: i < count - 1, children: _jsxs(ListItemButton, { onClick: () => choose(w), disabled: busyId !== null, selected: current, "aria-current": current ? 'true' : undefined, sx: { px: 2.5, py: 1.5, gap: 1.5, alignItems: 'center', borderRadius: 0 }, children: [_jsx(BrandMark, { name: w.tenantName, size: "sm", nameless: true }), _jsx(ListItemText, { primary: w.tenantName, secondary: _jsxs(Box, { component: "span", sx: {
                                                    display: 'inline-flex',
                                                    gap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                }, children: [_jsx(Badge, { label: TIER_LABEL[w.tier] }), _jsx(Typography, { component: "span", variant: "caption", color: "text.secondary", children: w.roles.map((r) => ROLE_LABEL[r]).join(', ') })] }), slotProps: {
                                                primary: { sx: { fontWeight: 500 } },
                                                secondary: { component: 'span' },
                                            } }), current && (_jsx(CheckIcon, { fontSize: "small", color: "success", "aria-label": "Current workspace" }))] }) }, w.tenantId));
                        }) }) })] }) }));
}
//# sourceMappingURL=switch-tenant-screen.js.map